var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKanaLogomark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2474_33039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.229 9.01659V21.0046C4.8203 21.0046 6.34643 20.3731 7.47165 19.249C8.59686 18.1249 9.229 16.6003 9.229 15.0106V3.02258C7.63771 3.02258 6.11158 3.65409 4.98636 4.77819C3.86115 5.90228 3.229 7.42688 3.229 9.01659Z",
    fill: "#28245C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0442 7.78125L10.8627 10.9611C10.5815 11.2421 10.4235 11.6232 10.4235 12.0205C10.4235 12.4179 10.5815 12.7989 10.8627 13.08L18.7947 21.004C19.3519 20.4474 19.7939 19.7866 20.0954 19.0594C20.397 18.3321 20.5522 17.5527 20.5522 16.7655C20.5522 15.9783 20.397 15.1989 20.0954 14.4716C19.7939 13.7444 19.3519 13.0836 18.7947 12.527L14.0442 7.78125Z",
    fill: "#28245C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1394 11.1703C20.1833 10.1272 20.7698 8.71256 20.7698 7.23752C20.7698 5.76248 20.1833 4.34783 19.1394 3.30471L18.8394 3.005L14.8959 6.93108L19.1394 11.1703Z",
    fill: "#28245C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2474_33039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.541,
    height: 18,
    fill: "white",
    transform: "translate(3.22949 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanaLogomark);
export default __webpack_public_path__ + "static/media/kana-logomark.c526fd6e0c7e15d6c0efc7d37abc3634.svg";
export { ForwardRef as ReactComponent };